import { styled, FormHelperText } from "@mui/material";
const HelperText = styled(FormHelperText)(() => ({
  marginTop: "8px",
  textAlign: "center"
}));
export {
  HelperText
};
